module.exports = __webpack_public_path__ + "media/3.bf732fc7.wav";